<template>
  <div
    class="block-overlay-canvas"
    @click.self="canCloseOutside ? closeOverlay() : ''"
    v-show="overlay">
    <div :style="style" ref="canvas">
      <div
        v-if="showCloseButton"
        class="close-icon"
        style="display: flex; justify-content: flex-end"
        @click="closeOverlay">
        <v-icon> mdi-close </v-icon>
      </div>
      <block-subcanvas
        v-show="overlay"
        :blocks="overlay.config.blocks"
        mode="edit"
        :style="styleCanvas"
        @create:draft="$emit('create:draft', $event)"
        :blockVariables="overlayVariables" />
    </div>
  </div>
</template>

<script>
import BlockSubcanvas from "./BlockSubcanvas.vue"

export default {
  components: { BlockSubcanvas },
  inject: ["blocksSelector", "slideStyleData"],
  props: ["defaultBlockStyles", "overlayId", "globalVariables"],
  computed: {
    parent() {
      return this.$refs.canvas
    },
    overlay() {
      const overlay = this.blocksSelector.overlaysQueue.find(overlay => overlay.id === this.overlayId)
      return overlay
    },
    overlayVariables() {
      return this.overlay.variables || this.globalVariables
    },
    style() {
      if (this.overlay) {
        return {
          position: "relative",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: `${this.overlay.config.width}px`,
          height: `${this.overlay.config.height}px`,
          borderRadius: `${this.overlay.config.style.borderRadius}px`,
          backgroundColor: this.overlay.config.style.backgroundColor || "white"
        }
      }
      return {}
    },
    styleCanvas() {
      return {
        fontFamily: this.defaultBlockStyles.fontFamily
      }
    },
    showGrid() {
      return this.slideStyleData.gridSize && this.gridX !== 1
    },
    gridX() {
      return this.slideStyleData.gridSize[0]
    },
    gridY() {
      return this.slideStyleData.gridSize[1]
    },
    canCloseOutside() {
      return !this.overlay.config.avoidClosingOutside
    },
    showCloseButton() {
      return !this.overlay.config.hideCloseButton
    }
  },
  methods: {
    closeOverlay() {
      const closeAllOverlays = this.overlay.config.closeAll

      this.blocksSelector.closeOverlay(closeAllOverlays)
    }
  }
}
</script>

<style scoped>
.close-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  z-index: 10;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  padding: 1rem 1rem;
}

.block-overlay-canvas {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
}
</style>